import {useState,useEffect} from 'react';
import {TextField,IconButton,InputAdornment} from '@mui/material';
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldTextArea=({row,fieldName,application,recordRules,readOnly,setFieldValue,setFieldChanged})=>{
    const fieldProp=row?.[fieldName];
    const fieldValue=fieldProp?.value;
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const [inputValue,setInputValue]=useState(fieldValue||"");
    const [isFieldChanged,setIsFieldChanged]=useState(false);
    const [expanded,setExpanded]=useState(false);

    useEffect(()=>{
        setInputValue(fieldValue||"");
    },[fieldValue]);
    
    return (
        <TextField
            inputProps={{maxLength:fieldProp?.ui_max_length,readOnly:readOnlyEvaluated}}
            sx={{div:{backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:""}}}
            multiline={true}
            rows={expanded?10:fieldProp?.ui_rows}
            style={{marginTop:"0px",marginBottom:"8px"}}
            id={fieldName}
            name={fieldName}
            type={'text'}
            fullWidth
            required={fieldProp?.required?fieldProp?.required:false}
            error={fieldProp?.validation_error?fieldProp?.validation_error:false}
            helperText={fieldProp?.validation_error_message?fieldProp?.validation_error_message:''}
            variant="outlined"
            size="small"
            label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
            value={inputValue}
            margin="normal"
            InputProps={{
                endAdornment:(
                    <InputAdornment position="end">
                        <IconButton onClick={()=>setExpanded(!expanded)} edge="end" size="small">{expanded?<ExpandLessIcon/>:<ExpandMoreIcon/>}</IconButton>
                    </InputAdornment>
                )
            }}
            onChange={(e)=>{
                if(!isFieldChanged){setIsFieldChanged(true)}
                setFieldChanged();
                setInputValue(e.target.value);
            }}
            onBlur={(e)=>{if(isFieldChanged){setFieldValue(fieldName,inputValue)};}}/>
    );
}

export default FieldTextArea;
